import * as React from 'react';
import { observer } from 'mobx-react';
import cn from 'classnames';

import CopyComponent from 'shared/newComponents/CopyComponent';

import './Snippet.modules.scss';

type Props = {
  code: string;
  className?: string;
  Instruction?: React.ReactNode;
  /** Переносить длинную строку вместо горизонтального скролла: для ссылок и ключей без пробелов */
  wrap?: boolean;
};

const Snippet: React.FC<Props> = ({
  code,
  className,
  Instruction,
  wrap = false
}) => {
  return (
    <div styleName="snippet" className={className}>
      {Instruction}
      <div styleName="snippet__body">
        <pre styleName={cn('snippet__code', wrap && 'snippet__code_wrap')}>
          <code>{code}</code>
        </pre>
        <div styleName="snippet__copy">
          <CopyComponent value={code} />
        </div>
      </div>
    </div>
  );
};

export default observer(Snippet);
